import http, { addTokenAndKeyParams } from '@/utils/http'

export const getBanner = data => {
  data.type = 1;
  return http({
    url: '/qxtx/h5/index/listBannerImage',
    method: 'post',
    data:addTokenAndKeyParams(data),
    isFromQxtx:true
  })
}
export const getGoodsList = data => {
  return http({
    url: '/qxtx/h5/index/listItems',
    method: 'post',
    data:addTokenAndKeyParams(data),
    isFromQxtx: true
  })
}
export const getGoodsDetail = data => {
  return http({
    url: '/qxtx/h5/index/itemDetail',
    method: 'post',
    data:addTokenAndKeyParams(data),
    isFromQxtx: true
  })
}
export const beforeConfirm = data => {
  return http({
    url: '/qxtx/h5/index/placeOrder',
    method: 'post',
    data: addTokenAndKeyParams(data),
    isFromQxtx: true
  })
}
export const getOrderList = data => {
  return http({
    url: '/qxtx/h5/findOrderList',
    params: addTokenAndKeyParams(data),
    isFromQxtx: true
  })
}
export const getOrderDetail = data => {
  return http({
    url: '/qxtx/h5/index/orderDetail',
    method: 'post',
    data: addTokenAndKeyParams(data),
    isFromQxtx: true
  })
}

export const confirmDetail = data => {
  return http({
    url: '/qxtx/h5/index/confirmDetail',
    method: 'post',
    data: addTokenAndKeyParams(data),
    isFromQxtx:true
  })
}
export const cancelOrder = data => {
  return http({
    url: '/gold/stableGold/cancelOrder',
    method: 'post',
    data: addTokenAndKeyParams(data),
  })
}

export const confirmOrder = data => {
  return http({
    url: '/qxtx/h5/index/confirmOrder',
    method: 'post',
    data: addTokenAndKeyParams(data),
    isFromQxtx: true
  })
}
export const goldConfirmOrder = data => {
  return http({
    url: '/gold/stableGold/payOrder',
    method: 'post',
    data: addTokenAndKeyParams(data),
  })
}
export const payOrder = data => {
  return http({
    url: '/qxtx/h5/index/payOrder',
    method: 'post',
    data: addTokenAndKeyParams(data),
    isFromQxtx:true
  })
}
export const goldPayOrder = data => {
  return http({
    url: '/gold/stableGold/payOrder',
    method: 'post',
    data: addTokenAndKeyParams(data),
    isFromQxtx:true
  })
}

export const checkVerifyStatus = data => {
  return http({
    url: '/qxtx/h5/getVerifyStatus',
    method: 'post',
    data: addTokenAndKeyParams(data),
    isFromQxtx: true
  })
}

export const getPayResult = data => {
  return http({
    url: '/qxtx/h5/index/getPayResult',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

export const logout = data => {
  return http({
    url: '/m/account/logout.json',
    method: 'post',
    data: addTokenAndKeyParams(data),
    isFromQxtx: true
  })
}

export const getListCategory = data => {
  return http({
    url: '/qxtx/h5/index/listCategoryAndItem',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}


export const getNations = data => {
  return http({
    url: '/qxtx/h5/index/nations',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

export const getNationsItems = data => {
  return http({
    url: '/qxtx/h5/index/listNationItems',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

export const getRealInfo = data => {
  return http({
    url: '/rest/realinfo',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

export const getRecommendItems = data => {
  return http({
    url: '/qxtx/h5/index/recommendItems',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

// 快捷支付申请
export const getTonlyOrderPay = data => {
  return http({
    url: '/qxtx/quickPay/h5/tonlyOrderPay',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}
// 快捷支付申请
export const resendSmsCode = data => {
  return http({
    url: ' /qxtx/quickPay/h5/resendSmsCode',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

// 快捷支付银行卡
export const getBindCard = data => {
  return http({
    url: '/gold/bindCard/h5/findUserBindCard',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

// 快捷支付商城确认支付
export const mallPay = data => {
  return http({
    url: '/qxtx/h5/index/payOrder',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

// 快捷支付商城支付状态
export const mallGetStatus = data => {
  return http({
    url: '/qxtx/h5/index/getPayResult',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

// 快捷支付黄金订单申请
export const goldTonlyOrderPay = data => {
  return http({
    url: '/gold/bindCard/h5/tonlyOrderPay',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}  
// 快捷支付黄金订单重新发送验证码
export const goldResendSmsCode = data => {
  return http({
    url: '/gold/bindCard/h5/resendSmsCode',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

// 快捷支付黄金订单确认支付
export const goldTonlyConfirmPay = data => {
  return http({
    url: '/gold/bindCard/h5/tonlyConfirmPay',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

// 快捷支付黄金订单支付状态
export const goldGetStatus = data => {
  return http({
    url: '/gold/bindCard/h5/getTonlyQuickBankStatus',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}

// 是否设置支付密码
export const getPayPassword = data => {
  return http({
    url: '/m/paypassword/status.json',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}
// 获取退款订单数
export const getRefundOrderCount = data => {
  return http({
    url: '/qxtx/h5/getRefundOrderCount',
    params: addTokenAndKeyParams(data)
  })
}

